import { Table, TableBody, TableHead, TableRow } from '@mui/material';
import moment from 'moment';
import { useTranslation } from 'react-i18next';

import { Enum, useAllEnums } from '~/data/enums';

import { TableDataColumn, TableHeaderColumn } from '../TableDataComponents';

import { EmplOtherHistoryType } from './data';
import { EmplOtherHistorySxStyles } from './EmplOtherHistoryStyles';

export type DataType = {
  data: EmplOtherHistoryType[];
};

export const EmplOtherHistory = (props: DataType) => {
  const { data: emplOtherHistory } = props;
  const { t } = useTranslation();
  const sxStyles = EmplOtherHistorySxStyles();

  const { allEnums } = useAllEnums();

  const jsonTrialPeriodOptions = [
    { code: 'P1M', name: `1 ${t('laMonth')}` },
    { code: 'P2M', name: `2 ${t('laMonths')}` },
    { code: 'P3M', name: `3 ${t('laMonths')}` },
    { code: 'P4M', name: `4 ${t('laMonths')}` },
    { code: 'P5M', name: `5 ${t('laMonths')}` },
    { code: 'P6M', name: `6 ${t('laMonths')}` },
  ];

  const getTrialPeriod = (id: string) => {
    if (id === undefined || id === '') return '';
    const item = jsonTrialPeriodOptions.find((en) => en.code === id);
    return item === undefined ? id : item.name;
  };

  const getEnumName = (enumValue: Enum[], id: string) => {
    if (id === undefined || id === '') return '';
    const specificEnum = enumValue.find((en) => en.code === id);
    return specificEnum === undefined ? id : specificEnum.name;
  };

  return (
    <>
      <Table cellSpacing="0" cellPadding="0" sx={sxStyles.tableHeader}>
        <TableHead>
          <TableRow>
            <TableHeaderColumn title={t('laStartDate')} />
            <TableHeaderColumn title={t('laEmploymentType')} />
            <TableHeaderColumn title={t('laCurrency')} />
            <TableHeaderColumn title={t('fTrialPeriod')} />
            <TableHeaderColumn title={t('laTrialPeriodEndDate')} />
            <TableHeaderColumn title={t('fLastDEmpl')} />
            <TableHeaderColumn title={t('fLastDTemp')} />
            <TableHeaderColumn title={t('laTerminationReason')} />
            <TableHeaderColumn title={t('fReasonFixTerm')} />
            <TableHeaderColumn title={t('fEmplPlannedEndDate')} />
            <TableHeaderColumn title={t('fEmplInfo')} />
          </TableRow>
        </TableHead>
        <TableBody>
          {emplOtherHistory.length > 0 ? (
            emplOtherHistory.map((e: EmplOtherHistoryType, index: number) => {
              return (
                <TableRow key={index}>
                  <TableDataColumn
                    title={moment(e.fEmplDateStart).format('DD.MM.YYYY')}
                    first={true}
                  />
                  <TableDataColumn
                    title={getEnumName(allEnums.EMPLOYMENT_TYPE, e.fEmplType)}
                  />
                  <TableDataColumn title={e.fEmplCurrency} />
                  <TableDataColumn title={getTrialPeriod(e.fEmplTrialPeriod)} />
                  <TableDataColumn
                    title={
                      e.fEmplTrialPeriodEndDate
                        ? moment(e.fEmplTrialPeriodEndDate).format('DD.MM.YYYY')
                        : ''
                    }
                  />
                  <TableDataColumn
                    title={
                      e.fEmplLastDateEmployment
                        ? moment(e.fEmplLastDateEmployment).format('DD.MM.YYYY')
                        : ''
                    }
                  />
                  <TableDataColumn
                    title={
                      e.fEmplTerminationDate
                        ? moment(e.fEmplTerminationDate).format('DD.MM.YYYY')
                        : ''
                    }
                  />
                  <TableDataColumn
                    title={getEnumName(
                      allEnums.EMPL_TERMINATION_REASON,
                      e.fEmplTerminationReason,
                    )}
                  />
                  <TableDataColumn
                    title={getEnumName(
                      allEnums.EMPL_FIXED_TERM_REASON,
                      e.fEmplFixedTermReason,
                    )}
                  />
                  <TableDataColumn
                    title={
                      e.fEmplPlannedEndDate
                        ? moment(e.fEmplPlannedEndDate).format('DD.MM.YYYY')
                        : ''
                    }
                  />
                  <TableDataColumn title={e.fEmplInfo ? e.fEmplInfo : ''} />
                </TableRow>
              );
            })
          ) : (
            <TableRow>
              <TableDataColumn first={true} title={`${t('laNoHistoryNow')}`} />
            </TableRow>
          )}
        </TableBody>
      </Table>
    </>
  );
};
